import { createStyles } from '@zn-material-ui'

export default () =>
  createStyles({
    agreementsWrap: {
      paddingTop: '84px',
    },
    pageHeader: {
      width: '100%',
      height: '64px',
      backgroundColor: '#fff',
      boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.1)',
      position: 'fixed',
      top: 0,
      left: 0
    },
    headerCon: {
      width: '1200px',
      height: '100%',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center'
    },
    logo: {
      width: '90px',
    },
    agreementsCon: {
      width: '1200px',
      margin: '0 auto',
      backgroundColor: '#fff',
      borderRadius: '2px',
      boxShadow: 'inset 0px -1px 0px 0px rgba(229,229,229,1)'
    },
    container: {
      padding: '0 35px 50px 35px',
      '& p': {
        textIndent: '2em'
      },
      '& em': {
        color: '#414953',
        lineHeight: '28px',
        fontWeight: 600,
        fontStyle: 'normal',
      },
    },
    title: {
      textAlign: 'center',
      padding: '50px 0',
      fontSize: '36px',
      color: '#414953',
      fontWeight: 500,
    },
    con: {
      fontSize: '14px',
      color: '#414953',
      lineHeight: '28px',
      fontWeight: 400,
    },
    footer: {
      paddingTop: '70px',
      fontSize: '18px',
      color: '#414953',
      textAlign: 'right',
    },
  })
